import React from 'react';
import './LoadingSpinner.scss';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'white';
  text?: string;
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = 'primary',
  text,
  fullScreen = false,
  className = '',
}) => {
  const baseClass = 'loading-spinner';
  const sizeClass = `${baseClass}--${size}`;
  const colorClass = `${baseClass}--${color}`;
  const fullScreenClass = fullScreen ? `${baseClass}--full-screen` : '';

  const spinnerClass = [
    baseClass,
    sizeClass,
    colorClass,
    fullScreenClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <div className={spinnerClass}>
      <div className={`${baseClass}__spinner`}>
        <div className={`${baseClass}__spinner-ring`}></div>
        <div className={`${baseClass}__spinner-ring`}></div>
        <div className={`${baseClass}__spinner-ring`}></div>
      </div>
      {text && <div className={`${baseClass}__text`}>{text}</div>}
    </div>
  );

  if (fullScreen) {
    return <div className={`${baseClass}-overlay`}>{content}</div>;
  }

  return content;
};

export default LoadingSpinner;
